var _g, _g2, _g3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHideColumns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,27.275V4.108c0-1.164-.944-2.108-2.108-2.108h-5.784c-1.164,0-2.108.944-2.108,2.108v33.166l10-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.725,46h5.166c1.164,0,2.108-.944,2.108-2.108v-5.166l-7.275,7.275Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,13.275V4.108c0-1.164-.944-2.108-2.108-2.108h-5.784c-1.164,0-2.108.944-2.108,2.108v19.166l10-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,34.725v9.166c0,1.164.944,2.108,2.108,2.108h5.784c1.164,0,2.108-.944,2.108-2.108v-19.166l-10,10Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.275,2h-5.166c-1.164,0-2.108.944-2.108,2.108v5.166l7.275-7.275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,20.725v23.166c0,1.164.944,2.108,2.108,2.108h5.784c1.164,0,2.108-.944,2.108-2.108V10.725l-10,10Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 21.951,
    y: -6.006,
    width: 4.097,
    height: 60.012,
    rx: 1.608,
    ry: 1.608,
    transform: "translate(24 -9.941) rotate(45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHideColumns);
export default __webpack_public_path__ + "static/media/icon-hide-columns.076fd1e23fca3ba37249852d277de0df.svg";
export { ForwardRef as ReactComponent };